import { parseDate } from '#shared/utils'
import { test } from 'last-validator'
import lodashIsDate from 'lodash-es/isDate'

export const isDate = test((value) => {
    const date = parseDate(value)
    return lodashIsDate(date) && !isNaN(date.getTime())
}, 'Neplatný formát dátumu.')
